import React from 'react';
import {Piece} from './pieces/piece';
import { firebase_db } from './config/firebase';
import Alert from './material/alert'
import {set_kifu, set_piece, set_control_piece, nifu, mate, check, control_pos} from './game';
import { Setting } from "./setting";
import { Mt } from "./pieces/mt";
import _ from 'lodash';
import Box from '@material-ui/core/Box';
import {Copyright} from './material/copywrite'
import Button from '@material-ui/core/Button';
import { TweetButton } from "./material/tweetButton";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIosSharp';
import Replay10OutlinedIcon from '@material-ui/icons/Replay10Outlined';
import Forward10OutlinedIcon from '@material-ui/icons/Forward10Outlined';
import {Board, Captured} from './board';

interface IGameKifuProps{
  start_pos: Piece[][];
  start_black_piece: number[];
  start_white_piece: number[];
  current_pos: Piece[][];
  current_black_piece: number[];
  current_white_piece: number[];
  control_piece: boolean[][];
  control_piece_sub: boolean[][];
  turn: boolean;
  clicked_piece: number;
  final_piece: number;
  is_black: boolean;
  is_black_sub: boolean;
  inversion_moves: number;
  moved_piece: number;
  promotion: boolean;
  is_mobile: boolean;
  room_id: string;
}

interface IGameKifuState{
  start_pos: Piece[][];
  start_black_piece: number[];
  start_white_piece: number[];
  current_pos: Piece[][];
  current_black_piece: number[];
  current_white_piece: number[];
  control_piece: boolean[][];
  control_piece_sub: boolean[][];
  turn: boolean;
  clicked_piece: number;
  final_piece: number;
  is_black: boolean;
  is_black_sub: boolean;
  moves: number;
  moves_sub: number;
  moves_max: number;
  inversion_moves: number;
  moved_piece: number;
  promotion: boolean;
  is_mobile: boolean;
  room_id: string;
  enter_room_invalid: boolean;
  my_name: string;
  your_name: string;
  inversion_total_num: number;
  inversion_turn: boolean;
  inversion_interval: number;
  inversion_num: number;
  kifu: number[];
  resign: boolean;
  result: boolean;
  top: boolean;
}

export class GameKifu extends React.Component<IGameKifuProps, IGameKifuState> {
  constructor(props: IGameKifuProps){
    super(props);
    this.state = {
      start_pos: this.props.start_pos,
      start_black_piece: this.props.start_black_piece,
      start_white_piece: this.props.start_white_piece,
      current_pos: this.props.current_pos,
      current_black_piece: this.props.current_black_piece,
      current_white_piece: this.props.current_white_piece,
      control_piece: this.props.control_piece,
      control_piece_sub: this.props.control_piece_sub,
      turn: this.props.turn,
      clicked_piece: this.props.clicked_piece,
      final_piece: this.props.final_piece,
      is_black: this.props.is_black,
      is_black_sub: this.props.is_black_sub,
      moves: -1,
      moves_sub: 0,
      moves_max: 0,
      inversion_moves: this.props.inversion_moves,
      moved_piece: this.props.moved_piece,
      promotion: this.props.promotion,
      is_mobile: this.props.is_mobile,
      room_id: this.props.room_id,
      enter_room_invalid: false,
      my_name: "",
      your_name: "",
      inversion_total_num: 0,
      inversion_turn: true,
      inversion_interval: 0,
      inversion_num: 0,
      kifu: set_kifu(),
      resign: false,
      result: false,
      top: false,
    }

    this.handleEnterRoomClose = this.handleEnterRoomClose.bind(this);
    this.addKifu = this.addKifu.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleTop = this.handleTop.bind(this);
    this.handleKifuTweet = this.handleKifuTweet.bind(this);
  }

  handleEnterRoomClose(){
    this.setState({
      enter_room_invalid: false,
    });
  }

  handleClick(i: number){
    return;
  }

  handleTop(){
    window.location.href='https://inversion-shogi-c121c.firebaseapp.com/';
  }

  handleKifuTweet(){
    const link = `反転将棋棋譜（${this.state.my_name} vs ${this.state.your_name}） https://inversion-shogi-c121c.firebaseapp.com/kifu/${this.state.room_id}/${(this.state.is_black ? "black" : "white")} #反転将棋`;
    window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(link));
  }

  // 棋譜の検証
  addKifu(my_kifu: number[], your_kifu: number[], inversion_total_num: number, inversion_interval: number, inversion_turn: boolean){
    let moves = 0;
    let my_idx = 0;
    let your_idx = 0;
    let kifu: number[] = [];
    let is_black = this.state.is_black;
    let is_black_sub = this.state.is_black_sub;
    let inversion_moves = 0;
    let inversion_num = 0;
    let current_black_piece = this.state.current_black_piece;
    let current_pos = this.state.current_pos;
    let current_white_piece = this.state.current_white_piece;
    let turn = this.state.turn;
    let clicked_piece = this.state.clicked_piece;
    let control_piece = set_control_piece();
    while(my_idx < my_kifu.length || your_idx < your_kifu.length){
      const is_own = ((moves&1) === 0 ? is_black : !is_black);
      if(is_own){
        if(my_idx >= my_kifu.length){
          break;
        }
      }
      else{
        if(your_idx >= your_kifu.length){
          break;
        }
      }
      let i = (is_own ? my_kifu[my_idx] : your_kifu[your_idx]);
      (is_own ? ++my_idx : ++your_idx);
      if(i === Setting.RESIGN){
        break;
      }
      if(i === Setting.INVERSION){
        if(is_own){
          if((turn !== is_black_sub) || (!inversion_turn === is_black_sub) || (inversion_total_num === inversion_num) || (moves < inversion_moves + inversion_interval) || check(current_pos, turn)){
            continue;
          }
        }
        else{
          if((turn === is_black_sub) || (inversion_turn === is_black_sub) || (inversion_total_num === inversion_num) || (moves < inversion_moves + inversion_interval) || check(current_pos, turn)){
            continue;
          }
        }
        kifu = kifu.concat(Setting.INVERSION);
        // 手番、反転回数の更新
        is_black_sub = !this.state.is_black_sub;
        clicked_piece = Setting.UNCLICKED;
        moves = moves + 1;
        inversion_num = inversion_num + 1;
        control_piece = set_control_piece();
        inversion_moves = moves + 1;
        continue;
      }
      let tmp_pos = _.cloneDeep(current_pos);  // 動かした後の盤面

      // 持ち駒をクリックしたとき
      if(i < Setting.WHITE * 2){
        if(clicked_piece === Setting.UNCLICKED){
          if((turn ? (i < Setting.WHITE && current_black_piece[i] > 0) : (i >= Setting.WHITE && current_white_piece[i - Setting.WHITE] > 0))){
            // 候補の列挙
            // 駒を打つときは王手がかかっていないかと、行き所がないか、二歩、打ち歩詰めをチェックすればよい
            let tmp_control_piece = set_control_piece(true);
            let num = (i >= Setting.WHITE ? i - Setting.WHITE : i);
            for(let x = 0; x < Setting.LENGTH; ++x){
              for(let y = 0; y < Setting.LENGTH; ++y){
                // 駒がある場所は置けない
                if(tmp_pos[x][y].piece_num() !== Setting.MT){
                  tmp_control_piece[x][y] = false;
                }
                else if(num === 4){
                  tmp_control_piece[x][y] = (turn ? y > 1 : y < Setting.LENGTH - 1 - 1);
                }
                else if(num === 5){
                  tmp_control_piece[x][y] = (turn ? y !== 0 : y !== Setting.LENGTH - 1);
                }
                else if(num === 6){
                  tmp_control_piece[x][y] = (turn ? y !== 0 : y !== Setting.LENGTH - 1);
                  tmp_pos[x][y] = set_piece(num, turn);
                  if(nifu(tmp_pos, x, turn)){
                    tmp_control_piece[x][y] = false;
                  }
                  // 打ち歩詰めかどうか
                  // 前に敵玉がいるときだけチェックすればよい
                  if((turn ? (y > 1 && tmp_pos[x][y - 1].piece_num() === 7 && tmp_pos[x][y - 1].turn() !== turn) : (y < Setting.LENGTH - 1 && tmp_pos[x][y + 1].piece_num() === 7 && tmp_pos[x][y + 1].turn() !== turn))){
                    if(mate(tmp_pos, (turn ? current_white_piece : current_black_piece), !turn)){
                      tmp_control_piece[x][y] = false;
                    }
                  }
                  // 盤面を戻す
                  tmp_pos[x][y] = new Mt();
                }
                if(tmp_control_piece[x][y]){
                  tmp_pos[x][y] = set_piece(num, turn);
                  tmp_control_piece[x][y] = !check(tmp_pos, turn);
                  tmp_pos[x][y] = new Mt();
                }
              }
            }
            control_piece = tmp_control_piece;
            clicked_piece = i;
          }
          continue;
        }
        clicked_piece = Setting.UNCLICKED;
        control_piece = set_control_piece();
        continue;
      }

      // 成りフラグをチェック
      let promoted_flag = false;
      if(i >= Setting.LENGTH * Setting.LENGTH + Setting.WHITE  *2){
        promoted_flag = true;
        i -= Setting.LENGTH * Setting.LENGTH;
      }
      // 持ち駒の分を引く
      let x: number = Math.floor((i - Setting.WHITE * 2) / Setting.LENGTH);
      let y: number = (i - Setting.WHITE * 2) % Setting.LENGTH;
      // 駒を掴んでないとき
      if(clicked_piece === Setting.UNCLICKED){
        // 手番の駒以外はダメ
        if(current_pos[x][y].piece_num() === Setting.MT || current_pos[x][y].turn() !== turn){
          continue;
        }
        // 候補の列挙
        // 王手がかかっていないかのみをチェックすればよい
        // 駒を成らないので候補に行き所がない駒が含まれることもあるが、チェックする必要はない
        // これは適切な移動ならば行き所のない駒はできないため
        let tmp_control_pos = control_pos(current_pos, turn, x, y, -1, -1, false);
        let tmp_control_piece = set_control_piece(false);
        for(let xx = 0; xx < Setting.LENGTH; ++xx){
          for(let yy = 0; yy < Setting.LENGTH; ++yy){
            if(tmp_control_pos[xx][yy] === 0){
              continue;
            }
            // 手番の駒はダメ
            if(current_pos[xx][yy].piece_num() !== Setting.MT && current_pos[xx][yy].turn() === turn){
              continue;
            }
            let piece = tmp_pos[xx][yy];
            tmp_pos[xx][yy] = tmp_pos[x][y];
            tmp_pos[x][y] = new Mt();
            tmp_control_piece[xx][yy] = !check(tmp_pos, turn);
            tmp_pos[x][y] = tmp_pos[xx][yy];
            tmp_pos[xx][yy] = piece;
          }
        }
        control_piece = tmp_control_piece;
        clicked_piece = i;
        continue;
      }

      // ここでは必ず盤面をクリックしている
      let current_control_piece = control_piece;
      // 候補になかったらダメ
      if(!current_control_piece[x][y]){
        control_piece = set_control_piece();
        clicked_piece = Setting.UNCLICKED;
        continue;
      }

      // 以下では正しい指し手であることが保証されている
      let tmp_black_piece = _.cloneDeep(current_black_piece);
      let tmp_white_piece = _.cloneDeep(current_white_piece);
      let xx: number = -1;
      let yy: number = -1;
      // 持ち駒を掴んでいるとき
      if(clicked_piece < Setting.WHITE * 2){
        // 先手の駒を掴んでいる場合
        // 掴むときに手番かチェックしているので、ここではチェックしなくてよい
        if(turn){
          // 持ち駒の更新
          --tmp_black_piece[clicked_piece];
          // 盤面の更新
          tmp_pos[x][y] = set_piece(clicked_piece, turn);
        }
        else{
          // 持ち駒の更新
          --tmp_white_piece[clicked_piece - Setting.WHITE];
          // 盤面の更新
          tmp_pos[x][y] = set_piece(clicked_piece - Setting.WHITE, turn);
        }
      }
      else{
        // 持ち駒の分を引く
        xx = Math.floor((clicked_piece - Setting.WHITE * 2) / Setting.LENGTH);
        yy = (clicked_piece- Setting.WHITE * 2) % Setting.LENGTH;
        let piece = tmp_pos[x][y];
        // 盤面の更新
        tmp_pos[x][y] = tmp_pos[xx][yy];
        tmp_pos[xx][yy] = new Mt();
        // 持ち駒の更新
        let num: number = piece.piece_num();
        if(num !== Setting.MT){
          // 成っている駒を生に戻す
          if(num > Setting.WHITE){
            num -= Setting.MT / 2;
          }
          turn ? ++tmp_black_piece[num] : ++tmp_white_piece[num];
        }
      }

      // 成れるときは聞く
      // 条件：盤面から3段目に移動または3段目から移動するときで、金と玉以外の成っていない駒のとき
      let num: number = tmp_pos[x][y].piece_num();
      let is_promoted: Boolean = false;
      if(xx !== -1 && (turn ? (y < 3 || yy < 3) : (y > Setting.LENGTH - 1 - 3 || yy > Setting.LENGTH - 1 - 3)) && num < Setting.WHITE && Setting.PIECES[num + Setting.MT / 2] !== ""){
        if(promoted_flag){
          tmp_pos[x][y].promote();
        }
      }
      kifu = kifu.concat(clicked_piece);
      kifu = kifu.concat((promoted_flag || is_promoted) ? i + Setting.LENGTH * Setting.LENGTH : i);
      current_pos = tmp_pos;
      current_black_piece = tmp_black_piece;
      current_white_piece = tmp_white_piece;
      control_piece = set_control_piece();
      turn = !turn;
      moves = moves + 1;
      clicked_piece = Setting.UNCLICKED;

      // 詰んでいたら対局終了
      if(mate(tmp_pos, (turn ? tmp_white_piece : tmp_black_piece), turn)){
        break;
      }

    }
    this.setState({
      kifu: kifu,
      moves_max: moves,
    });
  }

  // kifuの不正な指し手はないので手のチェックはしない
  // 反転数の更新も行う
  setBoard(target_moves: number){
    if(target_moves < 0){
      target_moves = 0;
    }
    if(target_moves > this.state.moves_max){
      target_moves = this.state.moves_max;
    }
    let cur = 0;
    let idx = 0;
    const kifu = this.state.kifu;
    let tmp_pos = _.cloneDeep(this.state.start_pos);
    let tmp_black_piece = _.cloneDeep(this.state.start_black_piece);
    let tmp_white_piece = _.cloneDeep(this.state.start_white_piece);
    let clicked_piece = Setting.UNCLICKED;
    let final_piece = Setting.UNCLICKED;
    let turn = true;
    let is_black_sub = this.state.is_black;
    let inversion_num = 0;
    let inversion_moves = 0;
    while(cur < target_moves){
      let i = kifu[idx];
      // 盤面を反転したとき
      if(i === Setting.INVERSION){
        is_black_sub = !is_black_sub;
        ++idx;
        ++cur;
        ++inversion_num;
        inversion_moves = cur;
        continue;
      }
      // 駒を掴んでいないとき
      if(clicked_piece === Setting.UNCLICKED){
        clicked_piece = kifu[idx];
        ++idx;
        continue;
      }
      // 持ち駒を掴んでいるとき
      if(clicked_piece < Setting.WHITE * 2){
        const x = Math.floor((i - Setting.WHITE * 2) / Setting.LENGTH);
        const y = (i - Setting.WHITE * 2) % Setting.LENGTH;
        // 先手の駒を掴んでいる場合
        if(turn){
          --tmp_black_piece[clicked_piece];
          // 盤面の更新
          tmp_pos[x][y] = set_piece(clicked_piece, turn);
        }
        else{
          // 持ち駒の更新
          --tmp_white_piece[clicked_piece - Setting.WHITE];
          // 盤面の更新
          tmp_pos[x][y] = set_piece(clicked_piece - Setting.WHITE, turn);
        }
        clicked_piece = Setting.UNCLICKED;
        final_piece = i;
        turn = !turn;
        ++cur;
        ++idx;
        continue;
      }
      // 持ち駒の分を引く
      // 成りフラグをチェック
      let promoted_flag = false;
      if(i >= Setting.LENGTH * Setting.LENGTH + Setting.WHITE * 2){
        promoted_flag = true;
        i -= Setting.LENGTH * Setting.LENGTH;
      }
      const x = Math.floor((i - Setting.WHITE * 2) / Setting.LENGTH);
      const y = (i - Setting.WHITE * 2) % Setting.LENGTH;
      const xx = Math.floor((clicked_piece - Setting.WHITE * 2) / Setting.LENGTH);
      const yy = (clicked_piece - Setting.WHITE * 2) % Setting.LENGTH;
      let piece = tmp_pos[x][y];
      // 盤面の更新
      tmp_pos[x][y] = tmp_pos[xx][yy];
      tmp_pos[xx][yy] = new Mt();
      // 持ち駒の更新
      let num: number = piece.piece_num();
      if(num !== Setting.MT){
        // 成っている駒を生に戻す
        if(num > Setting.WHITE){
          num -= Setting.MT / 2;
        }
        turn ? ++tmp_black_piece[num] : ++tmp_white_piece[num];
      }
      if(promoted_flag){
        tmp_pos[x][y].promote();
      }
      clicked_piece = Setting.UNCLICKED;
      final_piece = i;
      turn = !turn;
      ++cur;
      ++idx;
    }
    this.setState({
      current_pos: tmp_pos,
      current_black_piece: tmp_black_piece,
      current_white_piece: tmp_white_piece,
      final_piece: final_piece,
      moves_sub: target_moves,
      is_black_sub: is_black_sub,
      turn: turn,
      inversion_num: inversion_num,
      inversion_moves: inversion_moves,
    });
  }

  render() {
    let game: string = "game-info space";
    let black_name = "";
    let white_name = "";
    const is_black_sub = this.state.is_black_sub;
    if(!is_black_sub){
      game += " white";
      white_name = this.state.my_name;
      black_name = this.state.your_name;
    }
    else{
      black_name = this.state.my_name;
      white_name = this.state.your_name;
    }
    let moves = this.state.moves_sub;
    const legend = (is_black_sub ? `△${white_name}　▲${black_name}` : `▲${black_name}　△${white_name}`);
    const inversion_moves = this.state.inversion_moves;
    const inversion_interval = this.state.inversion_interval;
    const inversion_total_num = this.state.inversion_total_num;
    const inversion_num = this.state.inversion_num;
    const moves_max = this.state.moves_max;

    const is_mobile = this.state.is_mobile;

    const font_size = (is_mobile ? 'small' : 'large');
    const button_size = (is_mobile ? 'small' : 'medium');
    const inversion_button = (inversion_moves + inversion_interval > moves || inversion_total_num <= inversion_num ?
      <Button  variant="contained" size={font_size} disabled >
        {`反転(${inversion_total_num - inversion_num}/${inversion_total_num})\n${inversion_moves + inversion_interval}手目以降`}
      </Button>
      :
      <Button  variant="contained" color="primary" size={font_size} >
        {`反転(${inversion_total_num - inversion_num}/${inversion_total_num})\n${inversion_moves + inversion_interval}手目以降`}
      </Button>);
    const back10 = (this.state.moves === -1 && moves > 0 ?
      <Button variant="contained" onClick={() => this.setBoard(moves - 10)}>
        <Replay10OutlinedIcon fontSize={font_size}/>
      </Button>
      :
      <Button variant="contained" disabled >
        <Replay10OutlinedIcon fontSize={font_size}/>
      </Button>
      );
    const back1 = (this.state.moves === -1 && moves > 0 ?
      <Button variant="contained" onClick={() => this.setBoard(moves - 1)}>
        <ArrowBackIosIcon fontSize={font_size}/>
      </Button>
      :
      <Button variant="contained" disabled >
        <ArrowBackIosIcon fontSize={font_size}/>
      </Button>
      );
    const forward1 = (this.state.moves === -1 && moves < moves_max ?
      <Button variant="contained" onClick={() => this.setBoard(moves + 1)}>
        <ArrowForwardIosIcon fontSize={font_size}/>
      </Button>
      :
      <Button variant="contained" disabled >
        <ArrowForwardIosIcon fontSize={font_size}/>
      </Button>
      );
    const forwad10 = (this.state.moves === -1 && moves < moves_max ?
      <Button variant="contained" onClick={() => this.setBoard(moves + 10)}>
        <Forward10OutlinedIcon fontSize={font_size}/>
      </Button>
      :
      <Button variant="contained" disabled >
        <Forward10OutlinedIcon fontSize={font_size}/>
      </Button>
    );
    if(is_mobile){
      return (
        <div className="game" style={{whiteSpace: 'pre-line'}}>
          <div className="game-info">
            <div className="game">
              <div className="title">
                <Button  variant="text" style={{ fontSize: '30px', fontWeight: 'bold', height: '50px', width: '160px' }} onClick={this.handleTop}>
                  反転将棋
                </Button>
              </div>
              <div className="game-sub">
                {this.state.moves === -1 && moves_max > 0 &&
                  <div className="mobile-button">
                    <TweetButton
                      children={"棋譜をツイート"}
                      is_mobile={is_mobile}
                      onClick={() => this.handleKifuTweet()}
                    />
                  </div>
                }
                <div className="mobile-button">
                  {inversion_button}
                </div>
                {this.state.moves === -1 && moves_max > 0 &&
                  <div className="mobile-button">
                    <Button variant="contained" size={button_size} color="secondary" onClick={() => this.setBoard(0)}>
                      開始局面
                    </Button>
                  </div>
                }
                {this.state.moves === -1 && moves_max > 0 &&
                  <div className="mobile-button">
                    <Button variant="contained" size={button_size} color="primary" onClick={() => this.setBoard(moves_max)}>
                      終局図
                    </Button>
                  </div>
                }
              </div>
              <div className="center bold">
                {legend}
              </div>
              <div className="center">
                {back1}
                &nbsp;
                {moves}手目
                &nbsp;
                {forward1}
              </div>
              <div className={game}>
                <div className="mobile-game-info-white white">
                  <div>{"△"}</div>
                  <Captured
                    squares={this.state.current_white_piece}
                    clicked_piece={this.state.clicked_piece}
                    is_black={false}
                    turn={this.state.turn}
                    onClick={i => this.handleClick(i)}
                    is_mobile={is_mobile}
                  />
                </div>
                <div>
                  <Board
                    squares={this.state.current_pos}
                    onClick={i => this.handleClick(i)}
                    clicked_piece={this.state.clicked_piece}
                    control_piece={this.state.control_piece_sub}
                    final_piece={this.state.final_piece}
                    is_mobile={is_mobile}
                  />
                </div>
                <div className="mobile-game-info-black">
                  <div>{"▲"}</div>
                  <Captured
                    squares={this.state.current_black_piece}
                    clicked_piece={this.state.clicked_piece}
                    is_black={true}
                    turn={this.state.turn}
                    onClick={i => this.handleClick(i)}
                    is_mobile={is_mobile}
                  />
                </div>
              </div>
            </div>
          </div>
          <Box mt={8}>
            <Copyright />
          </Box>
          <Alert
            title={"棋譜が存在しません。"}
            message={""}
            open={this.state.enter_room_invalid}
            handleClose={this.handleEnterRoomClose}
          />
        </div>
      );
    }
    return (
      <div className="game" style={{whiteSpace: 'pre-line'}}>
        <div className="game-info">
          <div className="game">
            <div className="center bold">
              {legend}
            </div>
            <div className="center">
              {back10}
              &nbsp;
              {back1}
              &nbsp;
              {moves}手目
              &nbsp;
              {forward1}
              &nbsp;
              {forwad10}
            </div>
            <div className={game}>
              <div className="game-info-white white">
                <div>{"△"}</div>
                <Captured
                  squares={this.state.current_white_piece}
                  clicked_piece={this.state.clicked_piece}
                  is_black={false}
                  turn={this.state.turn}
                  onClick={i => this.handleClick(i)}
                  is_mobile={is_mobile}
                />
              </div>
              <div className="game-board">
                <Board
                  squares={this.state.current_pos}
                  onClick={i => this.handleClick(i)}
                  clicked_piece={this.state.clicked_piece}
                  control_piece={this.state.control_piece_sub}
                  final_piece={this.state.final_piece}
                  is_mobile={is_mobile}
                />
              </div>
              <div className="game-info-black">
                <div>{"▲"}</div>
                <Captured
                  squares={this.state.current_black_piece}
                  clicked_piece={this.state.clicked_piece}
                  is_black={true}
                  turn={this.state.turn}
                  onClick={i => this.handleClick(i)}
                  is_mobile={is_mobile}
                />
              </div>
            </div>
          </div>
          <div className="game-sub">
            <div className="title">
              <Button variant="text" style={{ fontSize: '30px', fontWeight: 'bold', height: '50px', width: '140px' }} onClick={this.handleTop}>
                反転将棋
              </Button>
            </div>
            {this.state.moves === -1 && moves_max > 0 &&
              <div className="button">
                <TweetButton
                  children={"棋譜をツイート"}
                  is_mobile={is_mobile}
                  onClick={() => this.handleKifuTweet()}
                />
              </div>
            }
            <div className="button">
              {inversion_button}
            </div>
            {this.state.moves === -1 && moves_max > 0 &&
                  <div className="button">
                    <Button variant="contained" size={button_size} color="secondary" onClick={() => this.setBoard(0)}>
                      開始局面
                    </Button>
                  </div>
                }
                {this.state.moves === -1 && moves_max > 0 &&
                  <div className="button">
                    <Button variant="contained" size={button_size} color="primary" onClick={() => this.setBoard(moves_max)}>
                      終局図
                    </Button>
                  </div>
                }
          </div>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
        <Alert
          title={"棋譜が存在しません。"}
          message={""}
          open={this.state.enter_room_invalid}
          handleClose={this.handleEnterRoomClose}
        />
      </div>
    );
  }

  componentDidMount(){
    const is_black = this.state.is_black;
    const my_turn = (is_black ? "black" : "white");
    const your_turn = (is_black ? "white" : "black");
    let inversion_total_num = 0;
    let inversion_turn = true;
    let inversion_interval = 0;
    let my_kifu: Array<number> = [];
    let your_kifu: Array<number> = [];
    const room_id = this.state.room_id;
    let self = this;

    // 部屋が存在するかチェック
    firebase_db.ref(`room/${room_id}/${my_turn}`).once("value", function(snapshot){
      if(snapshot.exists()){
        const my_id = snapshot.child("uid").val();
        self.setState({
          my_name: snapshot.child("name").val(),
        });
        // 反転数、反転手番をセット
        firebase_db.ref(`room/${room_id}/inversion`).once("value", function(snapshot2){
          if(snapshot2.exists()){
            inversion_total_num = snapshot2.child("num").val();
            inversion_turn = snapshot2.child("turn").val();
            inversion_interval = snapshot2.child("interval").val();
            self.setState({
              inversion_total_num: inversion_total_num,
              inversion_turn: inversion_turn,
              inversion_interval: inversion_interval,
            });
            firebase_db.ref(`room/${room_id}/${your_turn}`).once("value", function(snapshot3){
              if(snapshot3.exists()){
                const your_id = snapshot3.child("uid").val();
                self.setState({
                  your_name: snapshot3.child("name").val(),
                });
                firebase_db.ref(`player/${my_id}/${room_id}/${my_turn}`).once("value", function(data){
                  for(let item in data.val()){
                    my_kifu = my_kifu.concat(data.val()[item]["piece"]);
                  }
                  firebase_db.ref(`player/${your_id}/${room_id}/${your_turn}`).once("value", function(data2){
                    for(let item in data2.val()){
                      your_kifu = your_kifu.concat(data2.val()[item]["piece"]);
                    }
                    // 棋譜の検証
                    self.addKifu(my_kifu, your_kifu, inversion_total_num, inversion_interval, inversion_turn);
                  });
                });
              }
            });
          }
        });
      }
      else{
        self.setState({
          enter_room_invalid: true,
        });
      }
    });
  }
}
